var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52567",
    "data-name": "Group 52567",
    transform: "translate(-1174 -208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_499",
    "data-name": "Ellipse 499",
    transform: "translate(1174 208)",
    fill: "#fcfcfc",
    stroke: "#93a750",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Buy",
    "data-name": "Iconly/Bold/Buy",
    transform: "translate(1184 218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buy",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Buy-2",
    "data-name": "Buy",
    d: "M18.936,23.074A1.893,1.893,0,1,1,20.835,25,1.918,1.918,0,0,1,18.936,23.074Zm-14.052,0A1.893,1.893,0,1,1,6.782,25,1.918,1.918,0,0,1,4.885,23.074Zm2.1-3.956a3.136,3.136,0,0,1-2.158-.861A3.269,3.269,0,0,1,3.81,16.135L2.662,2.23.775,1.9A.958.958,0,0,1,.956,0,1.021,1.021,0,0,1,1.1.011L4.079.469a.96.96,0,0,1,.774.867L5.09,4.194a.771.771,0,0,0,.762.716H22.721a2.111,2.111,0,0,1,1.762.855,2.813,2.813,0,0,1,.475,2.193L23.77,16.325a3.227,3.227,0,0,1-3.16,2.793Zm7.232-8.533a.948.948,0,0,0,.937.956h3.459a.948.948,0,0,0,.937-.956.938.938,0,0,0-.937-.957H15.151A.938.938,0,0,0,14.214,10.585Z",
    transform: "translate(0 0)",
    fill: "#93a750"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/CartIcon.ed30a8fd9d5251377bc89f597ad18be3.svg";
export { ForwardRef as ReactComponent };